<mat-slide-toggle [(ngModel)]="value" [disabled]="disabled || readonly" (change)="change()">{{ title }}</mat-slide-toggle>

